import moment from "moment";
import travelBookingApiService from "../../../../services/travelBookingApiService";

const normalizeSuiteSize = (size) => {
  const map = {
    stu: "1x",
    "1/den": "1x",
    "1/town": "1x",
    "1x1": "1x",
    "2x2": "2x",
    "2x1": "2x",
    "3x3": "3x",
    "4x4": "3x",
    "5x": "3x",
    "4x": "3x",
    "6x": "3x",
  };
  return map[size] || size;
};

const getPrice = (map, suite) =>
  map[normalizeSuiteSize(suite)] || map[normalizeSuiteSize("3x3")];

const handleError = (error) => {
  console.log(error.message, "error");
};

export function calculateBookingPrices(suiteSize, monthlyrent) {
  console.log(suiteSize, monthlyrent, "communityData, monthlyrent");

  const suite = suiteSize?.toLowerCase();
  const rent = Number(monthlyrent || 0);
  if (!suite || !rent) {
    return {
      rent: 0,
      utilities: 0,
      cleaning: 0,
      housewares: 0,
      serviceFee: 0,
      totalAmount: "0.00",
    };
  }

  const prices = {
    utilities: { stu: 380, "1x": 380, "2x": 450, "3x": 520 },
    cleaning: { stu: 265, "1x": 265, "2x": 290, "3x": 320 },
    housewares: { "1x": 290, "2x": 365, "3x": 430 },
  };

  const utilities = getPrice(prices.utilities, suite);
  const cleaning = getPrice(prices.cleaning, suite);
  const housewares = getPrice(prices.housewares, suite);
  const serviceFee = +(0.1 * (rent + utilities + housewares)).toFixed(2);
  const total = +(rent + utilities + housewares + serviceFee).toFixed(2);
  // console.log({ rent, utilities, housewares, serviceFee });

  const format = (val) => val.toFixed(2);

  return {
    rent: format(rent),
    utilities: format(utilities),
    cleaning: format(cleaning),
    housewares: format(housewares),
    serviceFee: format(serviceFee),
    totalAmount: format(total),
  };
}

export function stayCalulation(state) {
  const {
    checkin,
    checkout,
    rent,
    utilities,
    serviceFee,
    cleaning,
    housewares,
  } = state;
  console.log({ rent, utilities, serviceFee, housewares });

  const stayDays = moment(checkout).diff(moment(checkin), "days") + 1;
  const stayMonths = stayDays / 30;
  console.log(stayMonths, "stayMonths");

  // const calcFee = (amount) => Number(((amount / 30) * stayDays).toFixed(2));
  const calcFee = (amount) => (amount / 30) * stayDays;

  const stayUtilitiesFee = calcFee(utilities);
  const stayHousewaresFee = calcFee(housewares);
  const stayServiceFee = calcFee(serviceFee);
  // console.log({ stayUtilitiesFee, stayHousewaresFee, stayServiceFee });

  const totalStayAmount = Number((rent * stayMonths).toFixed(2));
  // const totalStayAmount = rent * stayMonths;

  const totalAmount = Number(
    (
      totalStayAmount +
      stayUtilitiesFee +
      stayHousewaresFee +
      Number(cleaning) +
      stayServiceFee
    ).toFixed(2)
  );
  // const totalAmount =
  //   totalStayAmount + stayUtilitiesFee + stayHousewaresFee + stayServiceFee;

  return {
    stayUtilitiesFee,
    stayHousewaresFee,
    stayServiceFee,
    totalStayAmount,
    totalAmount,
  };
}

export function totalFullStayAmount(
  state,
  utilities,
  housewares,
  serviceFee,
  cleaning
) {
  const { checkin, checkout, rent } = state;
  // console.log(cleaning, "totalFullStayAmount");

  const stayDays = moment(checkout).diff(moment(checkin), "days") + 1;
  const stayDaysLimit = stayDays > 30 ? 30 : stayDays;
  console.log(stayDaysLimit, "stayDaysLimit", stayDays);

  const stayMonths = stayDays / 30;
  const stayMonthsLimit = stayDaysLimit / 30;

  // const calcFee = (amount, days) => Number(((amount / 30) * days).toFixed(2));
  const calcFee = (amount, days) => (amount / 30) * days;

  const stayUtilitiesFeeLimit = calcFee(utilities, stayDaysLimit);
  const stayHousewaresFeeLimit = calcFee(housewares, stayDaysLimit);
  const stayServiceFeeLimit = calcFee(serviceFee, stayDaysLimit);
  const totalStayAmountLimit = Number((rent * stayMonthsLimit).toFixed(2));
  const cleaningFee = stayDaysLimit >= stayDays ? Number(cleaning) : 0;
  // console.log(cleaningFee, "cleaningFee");

  const totalAmountLimit = Number(
    (
      totalStayAmountLimit +
      stayUtilitiesFeeLimit +
      stayHousewaresFeeLimit +
      stayServiceFeeLimit +
      cleaningFee
    ).toFixed(2)
  );

  const stayUtilitiesFeeFull = calcFee(utilities, stayDays);
  const stayHousewaresFeeFull = calcFee(housewares, stayDays);
  const stayServiceFeeFull = calcFee(serviceFee, stayDays);
  const totalStayAmountFull = Number((rent * stayMonths).toFixed(2));

  const totalAmountFull = Number(
    (
      totalStayAmountFull +
      stayUtilitiesFeeFull +
      stayHousewaresFeeFull +
      stayServiceFeeFull
    ).toFixed(2)
  );

  return {
    totalAmountLimit,
    totalAmountFull,
    stayDays,
  };
}

export async function calculateTempInvoice(state, totalAmount) {
  const { checkin, checkout, monthlyRent } = state;
  console.log(monthlyRent, "monthlyRent", totalAmount);

  let dayRent = totalAmount / 30;
  try {
    if (checkin && checkout) {
      let reqObject = {
        checkindate: checkin,
        checkoutdate: checkout,
        drent: dayRent,
      };
      // console.log(reqObject, "result", monthlyRent);

      let result = await travelBookingApiService.GetGenerateTempInvoices(
        reqObject
      );
      // console.log(result, "result", result.invicelist);

      if (result.error == "0") {
        return result.invicelist;
      } else {
        return [];
      }
    }
  } catch (error) {
    handleError(error);
  }
}

export function mergeInvoicesByDaysLimit(invoices, dayLimit = 30) {
  const merged = [];

  try {
    const totalDays = invoices.reduce((sum, inv) => sum + inv.InvoiceDays, 0);
    console.log(totalDays, "totalDays");

    // If all invoices combined are within dayLimit, merge all into one
    if (totalDays <= dayLimit) {
      const totalAmount = invoices.reduce(
        (sum, inv) => sum + inv.InvoiceAmount,
        0
      );
      const from = moment(invoices[0].InvoiceFromDate).format("MMM DD");
      const to = moment(invoices[invoices.length - 1].InvoiceToDate).format(
        "MMM DD"
      );
      const toDate = moment(invoices[invoices.length - 1].InvoiceToDate).format(
        "MM/DD/YYYY"
      );

      merged.push({
        from,
        to,
        toDate,
        totalDays: totalDays,
        InvoiceDays: totalDays,
        InvoiceAmount: parseFloat(totalAmount.toFixed(4)),
        InvoiceNote: "Due On Booking",
      });
    } else {
      // Use previous logic to group up to 45 days, then merge the rest as-is
      let currentGroup = [];
      let currentDays = 0;
      let currentAmount = 0;
      let firstGroupDone = false;

      for (let i = 0; i < invoices.length; i++) {
        const inv = invoices[i];
        const days = inv.InvoiceDays;

        if (!firstGroupDone && currentDays + days <= dayLimit) {
          currentGroup.push(inv);
          currentDays += days;
          currentAmount += inv.InvoiceAmount;

          if (currentDays === dayLimit) {
            // console.log(currentDays, "currentDays");

            const from = moment(currentGroup[0].InvoiceFromDate).format(
              "MMM DD"
            );
            const to = moment(
              currentGroup[currentGroup.length - 1].InvoiceToDate
            ).format("MMM DD");
            const toDate = moment(
              currentGroup[currentGroup.length - 1].InvoiceToDate
            ).format("MM/DD/YYYY");
            merged.push({
              from,
              to,
              toDate,
              InvoiceDays: currentDays,
              totalDays: totalDays,
              InvoiceAmount: parseFloat(currentAmount.toFixed(4)),
              InvoiceNote: "Due On Booking",
            });

            currentGroup = [];
            currentDays = 0;
            currentAmount = 0;
            firstGroupDone = true;
          }
        } else {
          if (!firstGroupDone && currentGroup.length > 0) {
            const from = moment(currentGroup[0].InvoiceFromDate).format(
              "MMM DD"
            );
            const to = moment(
              currentGroup[currentGroup.length - 1].InvoiceToDate
            ).format("MMM DD");
            const toDate = moment(
              currentGroup[currentGroup.length - 1].InvoiceToDate
            ).format("MM/DD/YYYY");
            merged.push({
              from,
              to,
              toDate,
              totalDays: totalDays,
              InvoiceDays: currentDays,
              InvoiceAmount: parseFloat(currentAmount.toFixed(4)),
              InvoiceNote: currentGroup[0].InvoiceNote || "",
            });

            firstGroupDone = true;
            currentGroup = [];
            currentDays = 0;
            currentAmount = 0;
          }

          const from = moment(inv.InvoiceFromDate).format("MMM DD");
          const to = moment(inv.InvoiceToDate).format("MMM DD");
          const toDate = moment(inv.InvoiceToDate).format("MM/DD/YYYY");
          const dueDate = moment(from).subtract(7, "days").format("MMM DD");
          // console.log(dueDate, "dueDate");

          merged.push({
            from,
            to,
            toDate,
            totalDays: totalDays,
            InvoiceDays: inv.InvoiceDays,
            InvoiceAmount: parseFloat(inv.InvoiceAmount.toFixed(4)),
            InvoiceNote: `Due ${dueDate}`,
          });
        }
      }
    }

    return merged;
  } catch (error) {
    console.error("Error merging invoices:", error);
    return [];
  }
}
